import { render, staticRenderFns } from "./filter_articles.vue?vue&type=template&id=ff083e28&scoped=true&"
import script from "./filter_articles.vue?vue&type=script&lang=js&"
export * from "./filter_articles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff083e28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff083e28')) {
      api.createRecord('ff083e28', component.options)
    } else {
      api.reload('ff083e28', component.options)
    }
    module.hot.accept("./filter_articles.vue?vue&type=template&id=ff083e28&scoped=true&", function () {
      api.rerender('ff083e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/news/list/filter_articles.vue"
export default component.exports